import menus from '@@/core/components/sidebar/menu.js'
export default {
  settingGroups: null,
  loading: false,
  menus: menus,
  permissions: null,
  admin: null,
  notifications: null,
  total_unread_notifications: 0,
  contacts: null,
  total_unread_contacts: 0,
  count_unread_guides: 0,
  today_sum_sell: 0,
  total_sum_sell: 0
}
